import React, { PureComponent } from "react";
import { connectStore } from "redux-box";
import { module as pronunciationLexicon } from "@st/pronunciationLexicon";
import PronunciationApi from "@s/api/pronunciation";
import {
  ModalOverlay,
  ModalBox,
  ModalTitle,
  FieldLabel,
  FieldInput,
  FieldSelect,
  PreviewContainer,
  PreviewTitle,
  PreviewButtonsRow,
  PreviewButton,
  ModalFooter,
  ModalCancelButton,
  ModalSaveButton,
} from "../PronunciationView.styled";

class PronunciationModal extends PureComponent {
  constructor(props) {
    super(props);
    const entry = this.props.pronunciationLexicon.selected;
    this.state = {
      word: entry ? entry.word : "",
      respelling: entry ? entry.respelling : "",
      voice: entry ? entry.voice : "",
      notes: entry ? entry.notes : "",
      match_type: "word",
      previewCurrentLoading: false,
      previewRespellingLoading: false,
    };
  }

  handleChange = (field, value) => {
    this.setState({ [field]: value });
  };

  handleSave = () => {
    const { word, respelling, voice, notes, match_type } = this.state;
    const data = { word, respelling, voice, notes, match_type };
    const entry = this.props.pronunciationLexicon.selected;
    if (entry) {
      this.props.pronunciationLexicon.requestUpdate(entry.id, data);
    } else {
      this.props.pronunciationLexicon.requestCreate(data);
    }
    this.props.onClose();
  };

  playAudio = async (text, isCurrent) => {
    const { voice } = this.state;
    const loadingKey = isCurrent ? "previewCurrentLoading" : "previewRespellingLoading";
    this.setState({ [loadingKey]: true });
    try {
      const result = await PronunciationApi.previewTTS(text, voice || "en-IN-NeerjaNeural", "+0%");
      if (result && result.audio_base64) {
        new Audio("data:audio/mp3;base64," + result.audio_base64).play();
      }
    } catch (e) {
      // silently fail preview
    } finally {
      this.setState({ [loadingKey]: false });
    }
  };

  render() {
    const { word, respelling, voice, notes, previewCurrentLoading, previewRespellingLoading } = this.state;
    const { voices } = this.props.pronunciationLexicon;
    const entry = this.props.pronunciationLexicon.selected;
    const isEdit = !!entry;

    return (
      <ModalOverlay>
        <ModalBox>
          <ModalTitle>{isEdit ? "Edit Entry" : "Add Entry"}</ModalTitle>

          <FieldLabel>
            Word
            <FieldInput
              type="text"
              value={word}
              onChange={(e) => this.handleChange("word", e.target.value)}
              placeholder="e.g. Leopard"
            />
          </FieldLabel>

          <FieldLabel>
            Respelling
            <FieldInput
              type="text"
              value={respelling}
              onChange={(e) => this.handleChange("respelling", e.target.value)}
              placeholder="e.g. LEP-erd"
            />
          </FieldLabel>

          <FieldLabel>
            Voice (leave blank for all voices)
            <FieldSelect
              value={voice}
              onChange={(e) => this.handleChange("voice", e.target.value)}
            >
              <option value="">All voices</option>
              {voices.map((v) => (
                <option key={v.key} value={v.key}>
                  {v.name}
                </option>
              ))}
            </FieldSelect>
          </FieldLabel>

          <FieldLabel>
            Notes
            <FieldInput
              type="text"
              value={notes}
              onChange={(e) => this.handleChange("notes", e.target.value)}
              placeholder="Optional notes"
            />
          </FieldLabel>

          <FieldLabel>
            Match Type
            <FieldInput type="text" value="word" readOnly />
          </FieldLabel>

          {word && respelling && (
            <PreviewContainer>
              <PreviewTitle>A/B Preview</PreviewTitle>
              <PreviewButtonsRow>
                <PreviewButton
                  onClick={() => this.playAudio(word, true)}
                  disabled={previewCurrentLoading}
                >
                  {previewCurrentLoading ? "Loading..." : "▶ Hear current"}
                </PreviewButton>
                <PreviewButton
                  variant="success"
                  onClick={() => this.playAudio(respelling, false)}
                  disabled={previewRespellingLoading}
                >
                  {previewRespellingLoading ? "Loading..." : "▶ Hear respelling"}
                </PreviewButton>
              </PreviewButtonsRow>
            </PreviewContainer>
          )}

          <ModalFooter>
            <ModalCancelButton onClick={this.props.onClose}>Cancel</ModalCancelButton>
            <ModalSaveButton onClick={this.handleSave}>Save</ModalSaveButton>
          </ModalFooter>
        </ModalBox>
      </ModalOverlay>
    );
  }
}

export default connectStore({ pronunciationLexicon })(PronunciationModal);
